export default __webpack_public_path__ + "static/banner-bg-b9f837d16e7526a4b191b3604a44c33d.png";